import { Button, FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import { lang } from 'botpress/shared'
import React, { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import style from './style.scss'

interface Props {
  onLogin: (email, password) => void
  /** Set only when the strategy enables self-service reset; otherwise no link is shown. */
  passwordResetUrl?: string
}

export const LoginForm: FC<Props> = props => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const onSubmit = e => {
    e.preventDefault()
    props.onLogin(email, password)
  }

  return (
    <form onSubmit={onSubmit}>
      <FormGroup className={cx('label_input', style.label_input)} label={lang.tr('email')}>
        <InputGroup
          tabIndex={1}
          value={email}
          onChange={e => setEmail(e.target.value)}
          type="text"
          id="email-login"
          autoFocus={true}
        />
      </FormGroup>

      <FormGroup className={cx('label_input', style.label_input)} label={lang.tr('admin.password')}>
        <InputGroup
          tabIndex={2}
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          id="password-login"
        />
      </FormGroup>

      <Button
        className={cx('login_btn_tgc', style.login_btn_tgc)}
        tabIndex={3}
        type="submit"
        id="btn-signin"
        text={lang.tr('admin.signIn')}
        disabled={!email || !password}
        intent={Intent.PRIMARY}
      />

      {props.passwordResetUrl && (
        <p className={style.forgotPasswordHint}>
          <Link to={props.passwordResetUrl} tabIndex={4}>
            {lang.tr('admin.forgotPassword')}
          </Link>
        </p>
      )}
    </form>
  )
}
